import tooltipconfig from "../config/tooltip";
import tippy from "tippy.js";
export default class Widget {
  _theme = "light";

  constructor() {
    this.wid = this.wid();
  }

  set theme(theme) {
    if (["light", "dark"].includes(theme)) {
      this._theme = theme;
    }
  }

  async getData(url) {
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      return await response.json();
    } catch (error) {
      console.warn(error);
      throw error;
    }
  }

  clearLoading() {
    this.div.querySelector(".sh-widget-loader").classList.add("hidden");
  }

  setTemplate(tmpl) {
    let wtemplate = tmpl.replace(/{wid}/g, this.wid);
    wtemplate = wtemplate.replace(/(\r\n|\n|\r)/gm, ""); // replace newlines?
    this.div.innerHTML = wtemplate;
  }

  setTitle(title) {
    this.div.querySelector('[data-element="title"]').innerHTML = title;
  }

  setTitleTooltip(content) {
    const tt = this.div.querySelector('[data-element="title-tooltip"]');
    tt.dataset.shWidgetTooltip = content;
  }

  setDescription(desc) {
    this.div.querySelector('[data-element="description"]').innerHTML = desc;
  }

  activateTooltips() {
    const tooltips = [].slice.call(
      this.div.querySelectorAll("[data-sh-widget-tooltip]")
    );
    tooltips.map(function (el) {
      const content = el.getAttribute("data-sh-widget-tooltip");
      tippy(el, {
        ...tooltipconfig,
        content: content,
      });
    });
  }

  // generate a random string for this widget to use as a unique identifier
  // and prevent conflicts with other widgets on the same page
  wid() {
    return Math.random().toString(36).slice(2, 7);
  }
}
